import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomDataTableHeader, CustomPanel, PageHeader } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import useCadastroInsumo, { LOADING_MESSAGES } from './CadastroInsumoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import CadastroInsumoModal from './CadastroInsumoModal'

function CadastroInsumo({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useCadastroInsumo()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (selectedTp) localDispatch.setLoadingMessageTo(LOADING_MESSAGES.FETCH_INSUMOS)
  }, [selectedTp])

  useEffect(() => {
    if (state.loadingMessage === LOADING_MESSAGES.FETCH_INSUMOS) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde'))
      localDispatch.fetchInsumos(selectedTp)
    } else if (state.loadingMessage === LOADING_MESSAGES.NONE) {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Render
  return (
    <>
      <PageHeader>7.1 - Insumo</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={localDispatch.onBtnNovo} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <DataTable
                value={state.insumos}
                emptyMessage={'Não existe nenhum Insumo cadastrado'}
                paginator={true}
                rows={10}
                selectionMode={'single'}
                onSelectionChange={e => localDispatch.onMenuItemClick(e.value)}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                globalFilter={globalFilter}
              >
                <Column field={'id'} header={'Código'} style={tableCellCentered()} />
                <Column field={'name'} header={'Insumo'} />
                <Column
                  field={'unidadeMovimentacao'}
                  header={'Uni. Mov.'}
                  style={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <CadastroInsumoModal
        visible={state.showModal}
        onResponse={localDispatch.onModalResponse}
        selectedInsumo={state.selectedInsumo}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })

export default connect(mapStateToProps)(withRouter(CadastroInsumo))
